import { OtherSimilarCardsWrapper, CardsList, CardItem } from './styles';

const OtherSimilarCards = ({ otherSimilarIdCards }) => {
  return (
    <OtherSimilarCardsWrapper>
      <CardsList>
        {otherSimilarIdCards.map((note, index) => (
          <CardItem key={index}>{note}</CardItem>
        ))}
      </CardsList>
    </OtherSimilarCardsWrapper>
  );
};

export default OtherSimilarCards;
